var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7071 8.29289C15.0976 8.68342 15.0976 9.31658 14.7071 9.70711L8.70711 15.7071C8.31659 16.0976 7.68342 16.0976 7.2929 15.7071L1.29289 9.70711C0.902369 9.31658 0.902369 8.68342 1.29289 8.29289C1.68342 7.90237 2.31658 7.90237 2.70711 8.29289L7 12.5858L7 1C7 0.447716 7.44772 -2.41411e-08 8 0C8.55229 2.41411e-08 9.00001 0.447716 9.00001 1L9 12.5858L13.2929 8.29289C13.6834 7.90237 14.3166 7.90237 14.7071 8.29289Z",
    fill: "currentColor"
  })));
}

export default SvgArrowDown;